// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"q4-z","dimensionLabel":"r4-z","styleChooserControlWrapper":"s4-z","styleChooserControl":"t4-z","disabled":"u4-z","giftCard":"v4-z","styleChooserText":"w4-z"};